import { Component, Input } from '@angular/core';

import { TabBarDistributionEnum } from './enums/navigation-tab-bar-distribution.enum';
import { NavigationTabBarButtonConfigInterface } from './interfaces/button.config.interface';

@Component({
  selector: 'app-navigation-tab-bar',
  templateUrl: './navigation-tab-bar.component.html',
  styleUrls: ['./navigation-tab-bar.component.scss'],
})
export class NavigationTabBarComponent {
  @Input() public buttonsConfig: NavigationTabBarButtonConfigInterface[] = [];
  @Input()
  public readonly distribution: TabBarDistributionEnum =
    TabBarDistributionEnum.Fluid;

  get distributionClass(): string {
    return this.distribution === TabBarDistributionEnum.Even
      ? 'navigation-tab-bar--even-distribution'
      : '';
  }

  public handleClick(
    buttonConfig: NavigationTabBarButtonConfigInterface
  ): void {
    if (typeof buttonConfig.click === 'function') {
      buttonConfig.click();
    }
  }
}
